import clsx from 'clsx'
import { FC } from 'react'

import { QueueNumberPriorityEnum } from '@models/queueNumber'

type Props = {
  priority: QueueNumberPriorityEnum
}

const QueueNodePriorityBadge: FC<Props> = ({ priority }) => {
  return (
    <div
      className={clsx('w-10px h-10px rounded-pill', {
        'bg-danger': priority === QueueNumberPriorityEnum.Red,
        'bg-warning': priority === QueueNumberPriorityEnum.Yellow,
        'bg-success': priority === QueueNumberPriorityEnum.Green,
      })}
    />
  )
}

export { QueueNodePriorityBadge }
